<template>
    <router-link :to="linkPath" :target="linkTarget" :class="linkClass" @click="trackLinkSelection">
        <span v-if="displayLabel">{{ linkLabel }}</span>
          <slot></slot>
    </router-link>
</template>

<script setup>
import { defineProps, defineEmits, ref, computed } from 'vue';
import { useStore } from 'vuex';
import { createPageVisitLog } from '@/services/PageVisitLog';

const store = useStore()

const props = defineProps(['link'])
const emit = defineEmits(['track-link-selection'])

  const previousTitle = ref('')
  const currentTitle = ref('')

const linkPath = computed(() => {
    return props.link ? props.link.path ? props.link.path : null : null
})

const linkLabel = computed(() => {
    return props.link ? props.link.label ? props.link.label : null : null
})

const displayLabel = computed(() => {
    return props.link ? props.link.displayLabel ? props.link.displayLabel : false : false
})

const linkTarget = computed(() => {
    return props.link ? props.link.target ? props.link.target : '' : ''
})

const linkClass = computed(() => {
  return props.link && props.link.class ? props.link.class : 'block'
})

  function trackLinkSelection(toPage) {
    console.log('to page', toPage)
    console.log(previousTitle.value, currentTitle.value, toPage)
    previousTitle.value = currentTitle.value
    currentTitle.value = toPage
    console.log(`log link selection from ${previousTitle.value} => ${toPage}`)
    const token = store.state.auth.token
    let data = JSON.stringify({
      from_page_name: previousTitle.value, 
      to_page_name: toPage
    })
    createPageVisitLog(token, data)
  }
</script>